import { StyleSheet, Text, View } from "react-native";

import {
  fonts,
  textRoles,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function PageTitle({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.wrap}>
      <Text style={stylesheet.title}>{title}</Text>
      {subtitle ? <Text style={stylesheet.subtitle}>{subtitle}</Text> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    wrap: { gap: 6 },
    title: {
      color: colors.heading,
      fontFamily: fonts.bold,
      fontSize: textRoles.pageTitle,
      letterSpacing: -0.2,
    },
    subtitle: {
      color: colors.mutedForeground,
      fontFamily: fonts.regular,
      fontSize: textRoles.pageSubtitle,
      lineHeight: textRoles.pageSubtitle * 1.5,
    },
  });
